<template>
  <div @mousemove="onMove" @mouseleave="reset" @click="click">
    <v-icon :icon="AddComponentIcon" size="20" @click="addClick()"
            class="position-absolute add-in" v-if="isTop !== null" :class="isTop ? 'top' : 'bottom'"/>
    <slot />
  </div>
</template>

<script setup>
import { ref } from 'vue';
import AddComponentIcon from "~/assets/icons/edit/add-second.vue";

const props = defineProps({
  block: { type: Number },
  component: { type: Number },
  view: { type: Boolean }
});
const emits = defineEmits(["add","click"]);

const isTop = ref(null)

const addClick = () => {
  emits('add', isTop.value)
}

const click = () => {
  emits('click')
}

const onMove = (e) => {
  if(props.view) return
  if('ontouchstart' in window || navigator.maxTouchPoints > 0) return
  const rect = e.currentTarget.getBoundingClientRect();
  const y = e.clientY - rect.top;
  const half = rect.height / 2;

  isTop.value = y < half;
}

const reset = () => {
  isTop.value = null
}
</script>

<style scoped lang="sass">
.add-in
  top: -11px
  z-index: 1
  left: calc(50% - 10px)
  &.bottom
    top: auto
    bottom: -11px
</style>
